import React, { useEffect, useState } from "react"
import Breakpoint, {
  BreakpointProvider,
  setDefaultBreakpoints
} from "react-socks"
import { header } from "react-bootstrap"
import { Link, useNavigate, useLocation } from "@reach/router"
import useOnclickOutside from "react-cool-onclickoutside"
import SideIcon from "../pages/sideIcon"
import Logo from "../../assets/images/Logo.png"
import swal from "sweetalert"
import { connect, useSelector, useDispatch } from "react-redux"
import {
  setActiveMenu,
  setConnectedWallet,
  setStakeTokenData,
  setStyleType,
  setTokenData,
  updateUserDetailsRedux
} from "../../redux/actions"

import Cookies from "universal-cookie"
import { mapStyleOptions, publicRoutes } from "../../Shared"
import "../../assets/css/headerfooter.css"
import { Images } from "../../Shared/images"
import { useLogout } from "../../hooks"
import { IoTUrl, NcashUrl, isNestEnabled } from "../../utils/config"

const cookies = new Cookies()

setDefaultBreakpoints([{ xs: 0 }, { l: 1199 }, { xl: 1200 }])

export const NavLink = props => (
  <Link
    {...props}
    getProps={({ isCurrent }) => {
      // the object returned here is passed to the
      // anchor element's props
      return {
        className: `${props?.buttonclass ?? ""} ${
          isCurrent ? "active" : "non-active"
        }`
      }
    }}
  />
)

const Header = function ({
  userDetails,
  updateUserDetails,
  setConnectedWalletRedux,
  ...props
}) {
  const [openMenu, setOpenMenu] = React.useState(false)
  const [openMenu1, setOpenMenu1] = React.useState(false)
  const [openMenu2, setOpenMenu2] = React.useState(false)
  const [openMenu3, setOpenMenu3] = React.useState(false)
  const [openSubMenu, setOpenSubMenu] = React.useState(null)
  const [background, setBackground] = useState("transparent")
  const loginUserpending = localStorage.getItem("loginUserpending")
  const loginDetails = useSelector(state => state.common.userDetails)
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const logoutHandler = useLogout()

  const isNewHeader = true

  const moniterNetworkStatus = () => {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", accountsChanged => {
        cookies.set("wallet", null, { path: "/" })
        cookies.set("wallet_status", 0, { path: "/" })
        window.location.reload()
      })
      window.ethereum.on("chainChanged", chainId => {
        cookies.set("wallet", null, { path: "/" })
        cookies.set("wallet_status", 0, { path: "/" })
        window.location.reload()
      })
    }
  }

  const handleBtnClick = () => {
    setOpenMenu(!openMenu)
  }
  const handleBtnClick1 = () => {
    setOpenMenu1(!openMenu1)
  }
  const handleBtnClick2 = () => {
    setOpenMenu2(!openMenu2)
  }
  const handleBtnClick3 = () => {
    setOpenMenu3(!openMenu3)
  }
  const closeMenu = () => {
    setOpenMenu(false)
  }
  const closeMenu1 = () => {
    setOpenMenu1(false)
  }
  const closeMenu2 = () => {
    setOpenMenu2(false)
  }
  const closeMenu3 = () => {
    setOpenMenu3(false)
  }
  const ref = useOnclickOutside(() => {
    closeMenu()
  })
  const ref1 = useOnclickOutside(() => {
    closeMenu1()
  })
  const ref2 = useOnclickOutside(() => {
    closeMenu2()
  })
  const ref3 = useOnclickOutside(() => {
    closeMenu3()
  })

  const [user, setUser] = useState(userDetails?.loginUser)
  const [showmenu, btn_icon] = useState(false)

  useEffect(() => {
    setUser(userDetails?.loginUser)
  }, [userDetails])

  useEffect(() => {
    if (location.pathname !== "/") {
      if (
        !publicRoutes.some(routeWord =>
          location.pathname.includes(routeWord)
        ) &&
        !userDetails?.loginUserToken
      ) {
        navigate("/login")
      }
    }
    // location.pathname === "/nest"
    //  ? setBackground("#161d30")
    //  : setBackground("transparent");
  }, [location.pathname])

  useEffect(() => {
    moniterNetworkStatus()
    const header = document.querySelector("header")
    const totop = document.getElementById("scroll-to-top")
    const sticky = header?.offsetTop
    const scrollCallBack = window.addEventListener("scroll", () => {
      btn_icon(false)

      if (!header || !totop) return
      if (window.pageYOffset > sticky) {
        header?.classList.add("sticky")
        totop?.classList.add("show")
      } else {
        header?.classList.remove("sticky")
        totop?.classList.remove("show")
      }
      if (window.pageYOffset > sticky) {
        closeMenu()
      }
    })
    const btn = document.querySelector(".icons")
    const nav = document.querySelector(".nav-collapse")
    const fa = document.querySelector(".fa-solid")

    btn?.addEventListener("click", function () {
      if (!nav) return

      nav.classList.toggle("open")
      if (fa.classList.contains("fa-bars")) {
        fa.classList.remove("fa-bars")
        fa.classList.add("fa-xmark")
      } else {
        fa.classList.remove("fa-xmark")
        fa.classList.add("fa-bars")
      }

      document.querySelector("#nav-ul").addEventListener("click", () => {
        if (!nav) return
        if (nav.classList.contains("open")) {
          nav.classList.toggle("open")
          fa.classList.remove("fa-xmark")
          fa.classList.add("fa-bars")
        }
      })
    })

    return () => {
      window.removeEventListener("scroll", scrollCallBack)

      document.querySelector("#nav-ul")?.removeEventListener("click", () => {
        if (nav.classList.contains("open")) {
          nav.classList.toggle("open")
          fa.classList.remove("fa-xmark")
          fa.classList.add("fa-bars")
        }
      })
    }
  }, [])

  const onLogout = () => {
    logoutHandler()
    swal({
      title: "Success!",
      text: "Logged out successfully",
      icon: "success"
    })
    navigate("/")
    // window.location.reload();
  }
  const toLinks = item => {
    window.open(item)
  }

  if (location.pathname === "/heatmap") return null

  if (!isNewHeader) {
    return (
      <header>
        {openMenu2 ? <div id="backdrop" onClick={closeMenu2}></div> : null}
        <div className="container mx-width">
          <Link to="/" className="logo">
            <img src={Images.Logo} alt="Nitro Network" />
          </Link>
          <nav className="nav-collapse">
            <ul className="dflex" id="nav-ul">
              {/* <li className="menu-item">
                <NavLink to="/">Home</NavLink>
                <div className="border">
                  <img src={Images.GlowLine} alt="Glowing Border" />
                </div>
              </li> */}

              <li className="menu-item">
                <NavLink to="/">Home</NavLink>
                <div className="border">
                  <img src={Images.GlowLine} alt="Glowing Border" />
                </div>
              </li>
              {/* Temporarily removed */}
              <li className="menu-item">
                <NavLink to="/marketplace">Marketplace</NavLink>
                <div className="border">
                  <img src={Images.GlowLine} alt="Glowing Border" />
                </div>
              </li>

              {isNestEnabled && (
                <li className="menu-item">
                  <NavLink to="/nest">Nest</NavLink>
                  <div className="border">
                    <img src={Images.GlowLine} alt="Glowing Border" />
                  </div>
                </li>
              )}

              {/*
                <li className="menu-item">
                  <NavLink to="/heatmap">Heatmap</NavLink>
                  <div className="border">
                    <img src={Images.GlowLine} alt="Glowing Border" />
                  </div>
                </li> 
                */}
              <li className="menu-item">
                <a href={IoTUrl} target="_blank">
                  IoT
                </a>
                <div className="border">
                  <img src={Images.GlowLine} alt="Glowing Border" />
                </div>
              </li>
              <li className="menu-item">
                <a href="/ncash" target="_blank">
                  NCash
                </a>
                <div className="border">
                  <img src={Images.GlowLine} alt="Glowing Border" />
                </div>
              </li>
              <li className="menu-item">
                <a href="https://swap.nitro.network" target="_blank">
                  Swap
                </a>
                <div className="border">
                  <img src={Images.GlowLine} alt="Glowing Border" />
                </div>
              </li>
              <li className="menu-item">
                <a href="https://staking.nitro.network" target="_blank">
                  Stake
                </a>
                <div className="border">
                  <img src={Images.GlowLine} alt="Glowing Border" />
                </div>
              </li>
              <li className="menu-item">
                <a href="/burn" target="_blank">
                  Burn
                </a>
                <div className="border">
                  <img src={Images.GlowLine} alt="Glowing Border" />
                </div>
              </li>
              <li className="menu-item">
                <a
                  href="https://buy.nitro.network/genesis-node"
                  target="_blank">
                  Genesis node
                </a>
                <div className="border">
                  <img src={Images.GlowLine} alt="Glowing Border" />
                </div>
              </li>
              <li className="menu-item">
                <NavLink to="/howitworks/howitworksnest">How It Works</NavLink>
                <div className="border">
                  <img src={Images.GlowLine} alt="Glowing Border" />
                </div>
              </li>
            </ul>
          </nav>

          <div className="mobile-view-nav">
            {userDetails.loginUserToken ? (
              <div className="navbar-item navbar-item1 relative">
                {/* <div ref={ref2}> */}
                <div
                  className="dropdo text-right-mobile"
                  onClick={handleBtnClick2}
                  id="username"
                  style={{ textAlign: "right" }}>
                  <div className="menu-item d-flex">
                    <span className="text-right">Hi {user}</span>
                    <span>
                      <i className="fa fa-caret-down"></i>
                    </span>
                  </div>
                </div>

                {openMenu2 && (
                  <div className="item-dropdown">
                    <div className="dropdown" onClick={closeMenu2}>
                      <NavLink
                        to={
                          loginUserpending == "true"
                            ? "/myaccount/pendingpayments"
                            : "/myaccount/mycollection"
                        }
                        onClick={() => dispatch(setActiveMenu("NFM"))}>
                        {" "}
                        <i className="fa fa-location-arrow"></i> My Account{" "}
                      </NavLink>
                      <NavLink to="/settings">
                        <i className="fa fa-user"></i> My Profile{" "}
                      </NavLink>

                      <NavLink to="/" onClick={onLogout}>
                        <i
                          className="fas fa-sign-out-alt"
                          aria-hidden="true"></i>{" "}
                        Logout
                      </NavLink>
                    </div>
                  </div>
                )}
                {/* </div> */}
              </div>
            ) : (
              <div className="btns-header">
                <li className="menu-item mr-in-desktop">
                  <NavLink to="/login" buttonclass="btn-ncta">
                    Sign In
                  </NavLink>
                </li>
                <li className="menu-item ml-2">
                  <NavLink buttonclass="btn-cta" to="/verifyEmail">
                    Sign Up
                  </NavLink>
                </li>
              </div>
            )}
            {!userDetails.loginUserToken ? (
              <div
                className="border mt-0 hide-it"
                style={{ display: "none !important" }}>
                <img src={Images.GlowLine} alt="Glowing Border" />
              </div>
            ) : null}
            <div className="icons">
              {/* <i className="fa fa-bars"></i> --> */}
              <i className="fa-solid fa-bars"></i>
              {/* <i className="fa-solid fa-xmark"></i> */}
            </div>
          </div>
        </div>
      </header>
    )
  }

  const headerLinks = [
    {
      id: 1,
      title: "Home",
      route: "/",
      submenus: []
    },
    {
      id: 2,
      title: "IoT",
      // route: "https://iot.lorvensofttech.com",
      submenus: [
        {
          title: "Marketplace",
          route: "https://iot.nitro.network/marketplace",
          openInNewTab: true
        },
        // {
        //   title: "Setup Guide",
        //   route: "https://iot.nitro.network/",
        //   openInNewTab: true
        // },
        {
          title: "Sensor Resources",
          route: "https://iot.nitro.network/resources",
          openInNewTab: true
        }
      ]
    },
    {
      id: 3,
      title: "NCash",
      // route: "https://iot.nitro.network",
      submenus: [
        {
          title: "Buy NCash",
          route: "/ncash"
        },
        {
          title: "Genesis Node",
          route: "https://buy.nitro.network/genesis-node",
          openInNewTab: true
        },
        {
          title: "Burn",
          route: "/burn"
        },
        {
          title: "Stake",
          route: "https://staking.nitro.network/",
          openInNewTab: true
        },
        {
          title: "Swap",
          route: "https://swap.nitro.network/",
          openInNewTab: true
        }
      ]
    },
    {
      id: 4,
      title: "NFT",
      // route: "https://iot.nitro.network",
      submenus: [
        {
          title: "Buy NFM",
          route: "/buy-nfm"
        },
        {
          title: "Buy NFM with Wallet",
          route: "https://buy.nitro.network/buy-nfm",
          openInNewTab: true
        },
        {
          title: "Buy NFM With EMI",
          route: "https://buy.nitro.network/EMI",
          openInNewTab: true
        }
      ]
    }
    // {
    //   id: 5,
    //   title: "How It Works",
    //   route: "/howitworks",
    //   submenus: []
    // }
  ]

  return (
    <header>
      {openMenu2 ? <div id="backdrop" onClick={closeMenu2}></div> : null}
      <div className="container mx-width">
        <Link to="/" className="logo">
          <img src={Images.Logo} alt="Nitro Network" />
        </Link>
        <nav className="nav-collapse">
          <ul className="dflex" id="nav-ul">
            {headerLinks.map((headerLink, index) => {
              return (
                <li
                  class="menu-item"
                  key={index}
                  onMouseEnter={() => setOpenSubMenu(index)}
                  onMouseLeave={() => setOpenSubMenu(null)}>
                  {/* If there are submenu open in <p>Tag  */}
                  {headerLink?.route && headerLink.submenus < 1 ? (
                    <NavLink to={headerLink?.route} className="menu-item-link">
                      {headerLink.title}
                    </NavLink>
                  ) : (
                    <p className="header__navlink-text">
                      {" "}
                      {headerLink.title}
                      {headerLink.submenus.length < 1 ? null : (
                        <i className="fa fa-caret-down"></i>
                      )}
                    </p>
                  )}

                  {/* Dropdown Popup */}
                  {headerLink.submenus.length < 1 ? null : (
                    <div
                      className={`header__navlink-relative ${
                        openSubMenu === index ? "active" : ""
                      }`}>
                      {headerLink?.submenus.map((submenu, subIndex) => {
                        return (
                          <a
                            href={submenu.route}
                            key={subIndex}
                            target={submenu?.openInNewTab ? "_blank" : "_self"}>
                            {submenu.title}{" "}
                          </a>
                        )
                      })}
                    </div>
                  )}
                </li>
              )
            })}
            {/* <li className="menu-item">
              <NavLink to="/">Home</NavLink>
            </li>

            <li
              className="header__navlink menu-item"
              onClick={() => {
                setOpenMenu1(!openMenu1)
              }}>
              <p className="header__navlink-text">
                IoT <i className="fa fa-caret-down"></i>
              </p>
              <div
                className={`header__navlink-relative ${
                  openMenu1 ? "active" : ""
                }`}>
                <a href="#">Marketplace</a>
                <a href="#">Setup Guide</a>
                <a href="#">Sensor Resources</a>
              </div>
            </li>

            <li
              className="header__navlink menu-item"
              onClick={() => {
                setOpenMenu2(!openMenu2)
              }}>
              <p className="header__navlink-text">
                NCash <i className="fa fa-caret-down"></i>
              </p>
              <div
                className={`header__navlink-relative ${
                  openMenu2 ? "active" : ""
                }`}>
                <a href="#">Buy Ncash</a>
                <a href="#">Genesis Node</a>
                <a href="#">Burn</a>
                <a href="#">Stake</a>
                <a href="#">Swap</a>
              </div>
            </li>

            <li className="header__navlink menu-item">
              <p
                className="header__navlink-text"
                onClick={() => {
                  setOpenMenu3(!openMenu3)
                }}>
                NFT <i className="fa fa-caret-down"></i>
              </p>
              <div
                className={`header__navlink-relative ${
                  openMenu3 ? "active" : ""
                }`}>
                <a href="#">Buy NFT</a>
                <a href="#">Buy With EMI</a>
              </div>
            </li>

            {isNestEnabled && (
              <li className="menu-item">
                <NavLink to="/nest">Nest</NavLink>
              </li>
            )}

            <li className="menu-item">
              <NavLink to="/howitworks/howitworksnest">How It Works</NavLink>
            </li> */}
          </ul>
        </nav>

        <div className="mobile-view-nav">
          {userDetails.loginUserToken ? (
            <div className="navbar-item navbar-item1 relative">
              {/* <div ref={ref2}> */}
              <div
                className="dropdo text-right-mobile"
                onClick={handleBtnClick2}
                id="username"
                style={{ textAlign: "right" }}>
                <div className="menu-item d-flex">
                  <span className="text-right">Hi {user}</span>
                  <span>
                    <i className="fa fa-caret-down"></i>
                  </span>
                </div>
              </div>

              {openMenu2 && (
                <div className="item-dropdown">
                  <div className="dropdown" onClick={closeMenu2}>
                    <NavLink
                      to={
                        loginUserpending == "true"
                          ? "/myaccount/pendingpayments"
                          : "/myaccount/mycollection"
                      }
                      onClick={() => dispatch(setActiveMenu("NFM"))}>
                      {" "}
                      <i className="fa fa-location-arrow"></i> My Account{" "}
                    </NavLink>
                    <NavLink to="/settings">
                      <i className="fa fa-user"></i> My Profile{" "}
                    </NavLink>

                    <NavLink to="/" onClick={onLogout}>
                      <i className="fas fa-sign-out-alt" aria-hidden="true"></i>{" "}
                      Logout
                    </NavLink>
                  </div>
                </div>
              )}
              {/* </div> */}
            </div>
          ) : (
            <div className="btns-header">
              <li className="menu-item mr-in-desktop">
                <NavLink to="/login" buttonclass="btn-ncta">
                  Sign In
                </NavLink>
              </li>
              <li className="menu-item ml-2">
                <NavLink buttonclass="btn-cta" to="/verifyEmail">
                  Sign Up
                </NavLink>
              </li>
            </div>
          )}
          {!userDetails.loginUserToken ? (
            <div
              className="border mt-0 hide-it"
              style={{ display: "none !important" }}>
              <img src={Images.GlowLine} alt="Glowing Border" />
            </div>
          ) : null}
          <div className="icons">
            {/* <i className="fa fa-bars"></i> --> */}
            <i className="fa-solid fa-bars"></i>
            {/* <i className="fa-solid fa-xmark"></i> */}
          </div>
        </div>
      </div>
    </header>
  )
}

const mapStateToProps = state => {
  return {
    userDetails: state.common.userDetails
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateUserDetails: payload => dispatch(updateUserDetailsRedux(payload)),
    setConnectedWalletRedux: payload => dispatch(setConnectedWallet(payload))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
